module.exports = __webpack_public_path__ + "static/media/t1.58ce0d8f.png";